<template>
  <div class="introduce">

    <h1 class="index-h2">公司介绍</h1>

    <el-row>
      <el-col class="col" :xs="24" :md="12" style="padding-left: 80px;">

        <h3 class="">浙江岩亨信息技术有限公司</h3>
        <span class="msg">ZheJiang YanHeng</span>
        <div class="hr"></div>
        <p>
          浙江岩亨信息技术有限公司成立于2017年3月，注册资金2150万元。
          是集人事外包、通信信息行业的业务外包、服务外包等多种经营模式和服务体系的专业外包服务供应商。
        </p>
        <br>
        <p>
			
        </p>
      </el-col>
      <el-col :xs="24" :md="12">
        <div class="img-box hvr-grow">
			<el-image src="https://yh-pro-1257088705.cos.ap-guangzhou.myqcloud.com/website/bg3.png" fit="none" class="img-box ">
            <div slot="placeholder" class="image-slot">
				加载中<span class="dot">...</span>
            </div>
          </el-image>
        </div>
      </el-col>
    </el-row>

  </div>
</template>


<script>
export default {
  data () {
    return {
      url: require('@/assets/image/bg3.png')

    }
  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.introduce {
  padding-bottom: 100px;
}
.el-row {
  display: flex;
  align-items: center;
}
.img-box{
	width: 500px;
	height: 252px;
}
.col {
  text-align: left;
  h3 {
    margin-bottom: 5px;
  }
  .hr {
    margin-top: 20px;
    margin-bottom: 20px;
    height: 2px;
    background-color: whitesmoke;
  }
  .msg {
    font-size: 14px;
  }

  p {
    font-size: 15px;
    line-height: 1.5em;
  }
}
</style>
<style lang="less" >
</style>